import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, ErrorIcon } from '@woovi/ui';

import type { PaymentActiveCreditCardFailed_charge$key } from './__generated__/PaymentActiveCreditCardFailed_charge.graphql.ts';
import PaymentLinkAdditionalInfo from '../../paymentLink/PaymentLinkAdditionalInfo.tsx';
import PaymentLinkComment from '../../paymentLink/PaymentLinkComment.tsx';
// eslint-disable-next-line
import PaymentLinkPaymentTerm from '../../paymentLink/PaymentLinkPaymentTerm.tsx';
import PaymentLinkTransactionDetails from '../../PaymentLinkTransactionDetails.tsx';

import type { ReactNode } from 'react';

type PaymentLinkActiveProps = {
  charge: PaymentActiveCreditCardFailed_charge$key;
};

const PaymentActiveCreditCardFailed = (
  props: PaymentLinkActiveProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();
  const charge = useFragment<PaymentActiveCreditCardFailed_charge$key>(
    graphql`
      fragment PaymentActiveCreditCardFailed_charge on Charge {
        id
        brCode
        identifier
        company {
          nameFriendly
          logo {
            url(fitIn: true)
          }
          projectType
          taxID {
            taxID
          }
        }
        ...PaymentLinkComment_charge
        ...PaymentLinkPaymentTerm_charge
        ...PaymentLinkAdditionalInfo_charge
        ...PaymentLinkTransactionDetails_charge
      }
    `,
    props.charge,
  );

  return (
    <BoxFlex
      sx={{
        flexDirection: 'column',
        alignItems: 'center',
        gap: '20px',
        mt: '20px',
      }}
    >
      <BoxFlex sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <ErrorIcon />
      </BoxFlex>
      <Typography
        variant={'h2'}
        sx={{
          fontSize: '22px',
          fontWeight: '800',
          textAlign: 'center',
          color: theme.palette.secondary.main,
        }}
      >
        {t('Payment Failed')}
      </Typography>
      <PaymentLinkComment charge={charge} />

      <BoxFlex
        sx={{
          flexDirection: 'column',
        }}
      >
        {/*<PaymentLinkPaymentTerm charge={charge} />*/}
        <PaymentLinkTransactionDetails charge={charge} />
        <PaymentLinkAdditionalInfo charge={charge} />
      </BoxFlex>
    </BoxFlex>
  );
};

export default PaymentActiveCreditCardFailed;
